import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { Pagination } from '../pagination/pagination';
import { UpsertVendorRequest, Vendor, VendorSearchRequest } from './vendor';
import { AxiosRequestConfig } from 'axios';
import { handleRequest } from '../quipli-service-client';
import { PaginationParsers } from '../pagination/pagination-parsers';
import { VendorParsers } from './vendor-parsers';
import VendorJson = VendorParsers.VendorJson;

export const useVendorApi = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function searchVendors(req: VendorSearchRequest): Promise<Pagination<Vendor>> {
    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/vendors/search`,
      headers: {
        'X-Tenant': tenant,
      },
      data: req,
    };

    const { items, pagination } = await handleRequest<PaginationParsers.PaginationJson<VendorJson>>(config);
    return {
      items: items.map(VendorParsers.toVendor),
      pagination,
    };
  }

  async function getVendor(vendorId: number): Promise<Vendor> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/vendors/${vendorId}`,
      headers: {
        'X-Tenant': tenant,
      },
    };

    const result = await handleRequest<VendorJson>(config);
    return VendorParsers.toVendor(result);
  }

  async function createVendor(req: UpsertVendorRequest): Promise<Vendor> {
    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/vendors`,
      headers: {
        'X-Tenant': tenant,
      },
      data: req,
    };

    const result = await handleRequest<VendorJson>(config);
    return VendorParsers.toVendor(result);
  }

  async function updateVendor(vendorId: number, req: UpsertVendorRequest): Promise<Vendor> {
    const config: AxiosRequestConfig = {
      method: 'put',
      url: `${contextPath}quipli-service/v1/vendors/${vendorId}`,
      headers: {
        'X-Tenant': tenant,
      },
      data: req,
    };

    const result = await handleRequest<VendorJson>(config);
    return VendorParsers.toVendor(result);
  }

  async function deleteVendor(vendorId: number) {
    const config: AxiosRequestConfig = {
      method: 'delete',
      url: `${contextPath}quipli-service/v1/vendors/${vendorId}`,
      headers: {
        'X-Tenant': tenant,
      },
    };

    await handleRequest(config);
  }

  return {
    searchVendors,
    getVendor,
    createVendor,
    updateVendor,
    deleteVendor,
  };
};
